module.exports = __webpack_public_path__ + "img/圣安塔影.82b63d28.jpg";